import LayoutWithSideMenu from '@/layout/layoutWithSideMenu/index.vue'

export const faultModule = {
  path: '/faultModule',
  name: 'faultModule',
  component: LayoutWithSideMenu,
  meta: {
    title: '故障模块'
  },
  children: [
    {
      path: 'faultOpen',
      name: 'faultOpen',
      component: () => import('@/views/faultModule/faultOpen/index.vue'),
      meta: {
        title: '故障开立'
      }
    },
    {
      path: 'failureLedger',
      name: 'failureLedger',
      component: () => import('@/views/faultModule/faultOpen/failureLedger.vue'),
      meta: {
        title: '故障台账'
      }
    },
    {
      path: 'faultOpenInfo/:type/:id',
      name: 'faultOpenInfo',
      component: () => import('@/views/faultModule/faultOpen/faultOpenInfo.vue'),
      meta: {
        title: '故障信息'
      }
    },
    {
      path: 'qmsTaskInfo',
      name: 'qmsTaskInfo',
      component: () => import('@/views/faultModule/qmsTaskInfo/index.vue'),
      meta: {
        title: 'QMS任务办理'
      }
    },
    {
      path: 'faultKnowledgeBase',
      name: 'faultKnowledgeBase',
      component: () => import('@/views/faultModule/faultKnowledgeBase/index.vue'),
      meta: {
        title: '故障知识库'
      }
    },
    {
      path: 'faultKnowledgeInfo/:type/:id',
      name: 'faultKnowledgeInfo',
      component: () => import('@/views/faultModule/faultKnowledgeBase/faultKnowledgeInfo.vue'),
      meta: {
        title: '故障知识库'
      }
    }
  ]
}
